"use client"

import { HandThumbDownIcon, HandThumbUpIcon } from "@heroicons/react/20/solid"
import { useState } from "react"
import { Button } from "@ui/button"
import mixpanel from "mixpanel-browser"

interface Props {
    correlationId: string
}

/**
 * Asks the user whether the answer is good or not using a simple thumbs up/down form.
 */
export function FeedbackForm({ correlationId }: Props) {
    const [feedback, setFeedback] = useState<"good" | "bad" | null>(null)
    const [status, setStatus] = useState<"ready" | "submitted" | "working">("ready")

    const submit = (feedback: "good" | "bad") => {
        setStatus("working")
        setFeedback(feedback)

        mixpanel.track(
            "Virtual Ray Feedback",
            {
                feedback,
                correlationId,
            },
            {
                send_immediately: true,
            },
            () => {
                setStatus("submitted")
            }
        )
    }

    return (
        <>
            <div className="space-y-4 py-5">
                <div className="mx-auto w-[20rem] space-y-4 rounded-lg border-2 border-gray-300 bg-white px-8 py-4">
                    {/* <h2 className="text-lg font-bold">Feedback</h2> */}
                    <p className="text-nowrap">Was this answer helpful?</p>
                    <div className="flex justify-around space-x-4">
                        <Button
                            className="size-16"
                            onClick={() => submit("bad")}
                            color={feedback === "bad" ? "primary" : "white"}
                            disabled={status === "submitted" || status === "working"}
                        >
                            <HandThumbDownIcon style={{ height: "2rem", width: "2rem", color: "darkred" }} />
                        </Button>
                        <Button
                            className="size-16"
                            onClick={() => submit("good")}
                            color={feedback === "good" ? undefined : "white"}
                            disabled={status === "submitted" || status === "working"}
                        >
                            <HandThumbUpIcon style={{ height: "2rem", width: "2rem", color: "darkgreen" }} />
                        </Button>
                    </div>
                    {status === "submitted" && <p className="text-black">Thank you for your feedback!</p>}
                </div>
            </div>
        </>
    )
}
